export const GlobalOrderFilterStatus = {
  REQUEST: 'Global_Order_Filter_Status_REQUEST',
  SUCCESS: 'Global_Order_Filter_Status_SUCCESS',
  ERROR: 'Global_Order_Filter_Status_ERROR',
  RESET: 'Global_Order_Filter_Status_RESET',
};
